
import { confirmAlert } from 'react-confirm-alert';
import "react-confirm-alert/src/react-confirm-alert.css";

import { ERROR_CODES } from '../constants';

const displayConfirmAlert = (message, callback) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        <div className='heading'>Thông Báo</div>
                        <h1>
                            {message}
                        </h1>
                        <div>
                            <button onClick={
                                () => {
                                    onClose()
                                    if(callback) callback()
                                }
                            }>Đồng Ý</button>
                        </div>
                    </div>
                )
            },
            closeOnClickOutside: false
        });
}

const displayConfirmChoiceAlert = (message, callback) => {
    confirmAlert({
        customUI: ({ onClose }) => {
            return (
                <div className='custom-ui'>
                    <div className='heading'>Xác nhận</div>
                    <h1>
                        {message}
                    </h1>
                    <div>
                        <button onClick={onClose}>Huỷ</button>
                        <button className='yes' onClick={
                            () => {
                                onClose()
                                if(callback) callback()
                            }
                        }>Đồng Ý</button>
                    </div>
                </div>
            )
        },
        closeOnClickOutside: false
    });
}

const displayConfirmChoiceAlert2 = (message, yesCallback, cancelCallback) => {
    confirmAlert({
        customUI: ({ onClose }) => {
            return (
                <div className='custom-ui'>
                    <div className='heading'>Xác nhận</div>
                    <h1>
                        {message}
                    </h1>
                    <div>
                        <button 
                            onClick={
                                () => {
                                    if(cancelCallback) cancelCallback();
                                    onClose();
                                }
                            }
                        >
                            Huỷ
                        </button>

                        <button className='yes' 
                            onClick={
                                () => {
                                    if(yesCallback) yesCallback();
                                    onClose();
                                }
                            }
                        >
                            Đồng Ý
                        </button>
                    </div>
                </div>
            )
        },
        closeOnClickOutside: false
    });
}

// const catchAxiosError = (toast, callback) => {
//     console.log("--- catchAxiosError", callback)
//     try {
//         callback();
//     } catch(error) {
//         console.log("--- error", error)
//         if(error?.code) {
//             toast({
//                 id: "global-error-info",
//                 description: `${ERROR_CODES[error?.code]} (${error?.code})`,
//                 status: "error",
//                 duration: 3000,
//                 isClosable: true,
//                 position: "bottom-right"
//             });
//         }
//     }
// }

export { displayConfirmAlert, displayConfirmChoiceAlert, displayConfirmChoiceAlert2 }
